import React, { FC, useCallback } from 'react';
import { Button, Col, ModalBody, ModalFooter, Row } from 'reactstrap';
import { PointsCriterion } from '../../../../../shared/orders/raffle';
import { Breadcrumb } from '../../../../components';
import { MaterialIconText } from '../../../../components/MaterialIconText';
import { useTranslation } from '../../../../translations';
import { RaffleConfiguratorProps } from '../utils';

export const PointsValue: FC<RaffleConfiguratorProps<PointsCriterion>> = ({
  displayName,
  onBack,
  onCancel,
  onConfigure,
}) => {
  const { ts } = useTranslation();
  const onFinish = useCallback(() => {
    onConfigure({ name: 'points', options: {} });
  }, [onConfigure]);

  return (
    <>
      <ModalBody>
        <Row>
          <Col xs={12}>
            <Breadcrumb
              items={[
                { text: `${ts('common.display_name')}: ${displayName ?? 'None'}` },
                { text: `${ts('type')}: Points Value` },
              ]}
            />
            <MaterialIconText name="keyboard_backspace" onClick={onBack}>
              {ts('common.go_back')}
            </MaterialIconText>
            <hr />
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button className="editor-finish-btn" color="primary" onClick={onFinish}>
          {ts('common.finish')}
        </Button>
        <Button className="editor-cancel-btn" color="secondary" onClick={onCancel} outline>
          {ts('common.cancel')}
        </Button>
      </ModalFooter>
    </>
  );
};
